<template>
  <div class="material-card"
       :class="{_big: isBig}"
  >
    <router-link-modified :to="{name: getToName, params: { newsSlug:item.slug }}"
                          class="material-card__inner">

      <template v-if="item.image_webp || item.image">
        <v-lazy-image v-if="isBig"
                      :src="item.image"
                      :title="createTitleMixin(item.title)"
                      :alt="createAltMixin(item.title)"
                      class="material-card__img"
                      use-picture>
          <source :srcset="item.image_webp"
                  type="image/webp">
        </v-lazy-image>

        <v-lazy-image v-else
                      :src="item.image"
                      :title="createTitleMixin(item.title)"
                      :alt="createAltMixin(item.title)"
                      class="material-card__img"
                      use-picture>
          <source :srcset="item.image_webp"
                  type="image/webp">
        </v-lazy-image>
      </template>
      <picture v-else
               class="material-card__img  _placeholder">
        <img src="@/assets/img/png/no-photo-placeholder.png"
             :alt="createAltMixin(item.title)">
      </picture>

      <div class="material-card__content">
        <time :datetime="(item.updated_at || item.created_at) | formatDateForTimeTag" class="material-card__date">
          {{ (item.updated_at || item.created_at) | formatDate }}
        </time>
        <h4 class="material-card__title">{{ item.title }}</h4>
        <div class="material-card__text text">
          <p>{{ item.excerpt }}</p>
        </div>
        <div class="material-card__content-footer">
          <!--        <div class="material-card__tags" v-if="item.article || item.document || item.video">-->
          <!--          <div class="material-card__tags-item material-tag _article" v-if="item.article">-->
          <!--            <BaseSvg name="ico-page-fill"/>-->
          <!--            <span>{{ $tAccount('Article') }}</span>-->
          <!--          </div>-->
          <!--          <div class="material-card__tags-item material-tag _document" v-if="item.document">-->
          <!--            <BaseSvg name="ico-clip-2"/>-->
          <!--            <span>{{ $tAccount('Document') }}</span>-->
          <!--          </div>-->
          <!--          <div class="material-card__tags-item material-tag _video" v-if="item.video">-->
          <!--            <BaseSvg name="ico-play-fill"/>-->
          <!--            <span>{{ $tAccount('Video') }}</span>-->
          <!--          </div>-->
          <!--        </div>-->
          <div class="material-card__tags-inline" v-if="item.tags && item.tags.length">
            # {{ (item.tags || []).join(' • ') }}
          </div>
        </div>
      </div>
    </router-link-modified>
  </div>
</template>

<script>
  export default {
    name: 'MaterialCard',
    props: {
      item: {
        type: Object
      },
      isBig: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      getToName() {
        let toNme
        if (this.isRouteNameMixin('account-useful-materials')) {
          toNme = 'useful-materials-single'
        } else {
          toNme = 'news-single-page'
        }
        return toNme
      }
    }
  }
</script>

<style>

</style>
